import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PekerjaanPascaService from "../../services/PekerjaanPascaService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataPekerjaan: [],
    dataPekerjaanByID:[],
    showMessage:false,
    message:''
}


export const getDataPekerjaan = createAsyncThunk('ref/pekerjaan_pasca',async (data, { rejectWithValue }) => {
    try {
        const response = await PekerjaanPascaService.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPekerjaanByID = createAsyncThunk('ref/pekerjaanbyid_pasca',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await PekerjaanPascaService.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const pekerjaanPascaSlice = createSlice({
    name: 'pekerjaan_pasca',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataPekerjaan = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPekerjaan.fulfilled, (state, action) => {
                state.loading = false
                state.dataPekerjaan = action.payload
            })
            .addCase(getDataPekerjaan.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPekerjaan.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPekerjaan = action.payload
            })
            .addCase(getDataPekerjaanByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataPekerjaanByID = action.payload
            })
            .addCase(getDataPekerjaanByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataPekerjaanByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataPekerjaanByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = pekerjaanPascaSlice.actions

export default pekerjaanPascaSlice.reducer
